import React from 'react';
export function Footer() {
  return <footer className="bg-brand-900 text-brand-100/60 py-16 text-center border-t border-brand-800/50" data-id="element-74">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-75">
        <div className="font-serif font-medium text-white text-2xl mb-4 tracking-tight" data-id="element-76">
          ITERA <span className="text-accent-400" data-id="element-77">PRO</span>
        </div>
        <p className="text-sm leading-relaxed max-w-2xl mx-auto font-normal" data-id="element-78">
          Sistemas listos para implementar.
        </p>
        <div className="flex flex-wrap justify-center gap-6 text-sm text-brand-200/60 mt-8 mb-8" data-id="element-79">
          <a href="#" className="hover:text-white transition-colors" data-id="element-80">
            Términos y condiciones
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-81">
            Política de privacidad
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-82">
            Política de devoluciones
          </a>
        </div>
        <div className="mt-8 text-xs text-brand-200/40 font-normal" data-id="element-83">
          &copy; {new Date().getFullYear()} Arte Lista. Todos los derechos
          reservados.
        </div>
      </div>
    </footer>;
}